<template>
  <div class="d-flex justify-content-between">
    <!-- CHECKIN -->
    <div class="text-left">
      <h4 class="font-weight-bold mb-1">
        {{ $t("Checkin", locale) }}
      </h4>
      <div v-if="previousCheckin && previousCheckin !== checkin" class="text-muted mb-25">
        <s>{{ previousCheckin }}</s>
      </div>
      <div class="mb-25">
        {{ checkin }}
      </div>
      <small v-if="!hideTimes">{{
        $t("emails.common.timesFrom16", locale)
      }}</small>
    </div>

    <!-- CHECKOUT -->
    <div class="text-right">
      <h4 class="font-weight-bold mb-1">
        {{ $t("Checkout", locale) }}
      </h4>
      <div v-if="previousCheckout && previousCheckout !== checkout" class="text-muted mb-25">
        <s>{{ previousCheckout }}</s>
      </div>
      <div class="mb-25">
        {{ checkout }}
      </div>
      <small v-if="!hideTimes">{{
        $t("emails.common.timesUpTo10", locale)
      }}</small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checkin: {
      type: String,
      required: true,
    },
    checkout: {
      type: String,
      required: true,
    },
    previousCheckin: {
      type: String,
      default: null,
    },
    previousCheckout: {
      type: String,
      default: null,
    },
    locale: {
      type: String,
      required: true,
    },
    hideTimes: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
